import { endOfDay, max as maxDate, startOfDay } from 'date-fns'
import { useFormContext, useWatch } from 'react-hook-form'

import { BID_ANALYSIS_EARLIEST_DATE, TimePeriod } from 'components/reports/Metrics/constants'
import { BidAnalysisInputDtoInput } from 'generated/graphql'
import { resolvePeriod } from 'helpers/metricsPeriod.helpers'

import { BidAnalysisFilterValues } from './BidAnalysisFilterCriteria'

interface QueryInput {
  start: Date | null
  end: Date | null
  hasValidRange: boolean
  isCustom: boolean
  input: BidAnalysisInputDtoInput
}

export const useBidAnalysisQueryInput = (): QueryInput => {
  const { control } = useFormContext<BidAnalysisFilterValues>()
  const period = useWatch({ control, name: 'period' })
  const customStart = useWatch({ control, name: 'customStart' })
  const customEnd = useWatch({ control, name: 'customEnd' })
  const selectedServiceCodes = useWatch({ control, name: 'selectedServiceCodes' })
  const vehicleType = useWatch({ control, name: 'vehicleType' })

  const isCustom = period === ('custom' as TimePeriod)

  const hasCompleteCustomRange = isCustom && customStart != null && customEnd != null

  const { start: rawStart, end } = hasCompleteCustomRange
    ? { start: startOfDay(customStart), end: endOfDay(customEnd) }
    : resolvePeriod(period === 'custom' ? 'last30' : period)

  const start = rawStart ? maxDate([rawStart, BID_ANALYSIS_EARLIEST_DATE]) : null

  const hasValidRange = start != null && end != null && start <= end

  return {
    start,
    end,
    hasValidRange,
    isCustom,
    input: {
      start: start ?? new Date(),
      end: end ?? new Date(),
      xeroCodeIds: selectedServiceCodes?.length
        ? selectedServiceCodes.map((option) => option.value)
        : null,
      vehicleType,
    },
  }
}
